import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { Button } from '../button';

interface DropdownProps {
  disabled?: boolean;
  label: string;
  options: Array<{ label: string; onClick: () => void }>;
  variant?: 'primary' | 'secondary';
}

export function Dropdown({ disabled, label, options, variant = 'primary' }: DropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <Container ref={dropdownRef}>
      <Button disabled={disabled} label={label} onClick={() => setIsOpen(!isOpen)} variant={variant} />
      {isOpen && (
        <DropdownMenu>
          {options.map((option) => (
            <MenuItem
              key={option.label}
              onClick={() => {
                option.onClick();
                setIsOpen(false);
              }}
            >
              {option.label}
            </MenuItem>
          ))}
        </DropdownMenu>
      )}
    </Container>
  );
}

const Container = styled.div`
  position: relative;
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 150px;
`;

const MenuItem = styled.button`
  width: 100%;
  padding: 8px 16px;
  border: none;
  background: none;
  text-align: left;
  color: #333;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background: #f5f5f5;
  }
`;
